import { render, staticRenderFns } from "./TasksSection.vue?vue&type=template&id=f795cf68&scoped=true"
import script from "./TasksSection.vue?vue&type=script&lang=ts"
export * from "./TasksSection.vue?vue&type=script&lang=ts"
import style0 from "./TasksSection.vue?vue&type=style&index=0&id=f795cf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f795cf68",
  null
  
)

export default component.exports